<template>
  <el-dialog
    :visible.sync="visible"
    class="as-order-dialog"
    title="请赶快处理该条售后申请吧~"
    width="360px"
    center
    :append-to-body="true"
    :before-close="setOrderFlag"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="header">
      <i class="el-icon-close" @click="visible = false"></i>
      <div class="as-order-title">请赶快处理该条售后申请吧~</div>
      <el-button
        type="primary"
        style="margin-bottom: 16px;"
        @click="handleConfirm"
        >我已收到货，立即去确认</el-button
      >
      <div class="btn-default" @click="handleCreate">
        未收到货/货物有异常，去建工单
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { getAftersaleDetail } from "@/models/aftersaleModel";

export default {
  name: "asOrderDialog",
  props: ["item"],
  data() {
    return { visible: false };
  },

  methods: {
    showDialog() {
      this.visible = true;
    },
    hideDialog() {
      this.visible = false;
      this.$emit("closeDialog");
    },
    setOrderFlag() {},
    // 确认
    async handleConfirm() {
      // console.log("item--", this.item);

      const isPingTai = localStorage.getItem("shop_type") === "0";
      const isZhifaOrFactory =
        localStorage.getItem("shop_type") === "1" ||
        localStorage.getItem("shop_type") === "2";
      if (this.item.asType == 1) {
        //退货
        if (isPingTai) {
          // this.visible = false;
          this.hideDialog();
          this.$router.push({
            path: "/afterSale/detail",
            query: {
              number: this.item.number, //售后单号
              order_type: "0", // 0-普通单子，2-谷仓单子（默认普通单）
              type: "accept" //售后确认
            }
          });
        } else {
          try {
            let params = {
              as_number: this.item.number,
              order_type: 0
            };
            const res = await getAftersaleDetail(params);
            // this.visible = false;

            this.hideDialog();
            this.$store.dispatch("app/isQueryPendingOrder", false);
            this.$store.dispatch("app/isQueryPendingAsOrder", false);
            let type = "";
            const status = Number(res.as_status);
            if (status < 21) {
              type = "receive"; //售后收货
            } else if (status < 23) {
              type = "accept"; //售后确认
            }
            this.$router.push({
              path: "/afterSale/detail",
              query: {
                number: this.item.number, //售后单号
                order_type: "0",
                type
              }
            });
          } catch (error) {
            this.$message.error(error.message);
          }
        }
      } else if (this.item.asType == 3) {
        //维修
        try {
          let params = {
            as_number: this.item.number,
            order_type: 0
          };
          const res = await getAftersaleDetail(params);
          // this.visible = false;
          this.hideDialog();
          this.$store.dispatch("app/isQueryPendingOrder", false);
          this.$store.dispatch("app/isQueryPendingAsOrder", false);
          let type = "";
          const status = Number(res.as_status);
          if (status < 21 && isZhifaOrFactory) {
            type = "receive"; //售后收货
          } else if (status < 22) {
            type = "accept"; //售后确认
          } else if (status >= 22 && status < 31) {
            type = "return"; //售后出库
          }
          this.$router.push({
            path: "/afterSale/detail",
            query: {
              number: this.item.number, //售后单号
              order_type: "0",
              type
            }
          });
        } catch (error) {
          this.$message.error(error.message);
        }
      }
    },
    // 新建工单
    handleCreate() {
      // console.log("跳转工单页面，并打开新建弹框", this.$route);
      this.visible = false;
      this.$store.dispatch("app/isQueryPendingOrder", false); //关闭
      this.$store.dispatch("app/isQueryPendingAsOrder", false);
      this.$nextTick(() => {
        const query = {
          sourceNo: this.item.number //售后单号
        };
        // 解决当前页面监听路由参数不变化，不能弹出创建工单弹框
        if (this.$route.path === "/orderList/work") {
          query.random = Math.floor(Math.random() * 10 + 1);
        }
        this.$router.push({
          path: "/orderList/work",
          query
        });
      });
    }
  }
};
</script>
<style lang="scss">
.as-order-dialog {
  .el-dialog.el-dialog--center {
    border-radius: 10px;
  }

  .el-dialog__header {
    display: none !important;
  }

  .el-dialog__body {
    color: inherit;
  }
  .header {
    text-align: center;
    .as-order-title {
      margin: 16px auto;
      font-size: 18px;
    }
  }
  .el-icon-close {
    position: absolute;
    right: 16px;
    top: 16px;
    font-size: 20px;
    cursor: pointer;
  }
  .btn-default {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: 0.1s;
    transition: 0.1s;
    font-weight: 500;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pendingOrder/asOrderDialog.vue